import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Input, Label } from "reactstrap";
import * as Icon from "react-feather";
import classNames from "classnames";

import CustomInput from "./CustomInput";
import SearchUserInput from "./SearchUserInput";
import { isUUID } from "../../helpers/utils";

const VIDEO_TYPES = ['LECTURE', 'VIDEOS', 'SEEDS', 'HOTS'];

const VideoFilter = ({ onSubmitFilter, loading }) => {

  var videoIdInput = useRef(null);
  var keywordInput = useRef(null);

  const [cancelDebounce, setCancelDebounce] = useState(false);
  const [validateErrors, setValidateErrors] = useState({});

  const [filters, setFilters] = useState({
    videoId: '',
    videoOwner: '',
    videoUser: '',    
    types: VIDEO_TYPES,
    keywords: '',
    reload: false
  });

  const fetching = false;

  const handleKeywordChange = (value) => {
    setFilters({ ...filters, keywords: value });
    setCancelDebounce(false);
  }

  const handleKeywordSubmit = (keywords) => {
    setFilters({ ...filters, keywords: keywords, reload: true });
  };

  const handleVideoIdChange = (value) => {
    if (value && !isUUID(value)) {
      setValidateErrors({
        ...validateErrors,
        videoId: 'Video id must be in uuid format.'
      });
    } else {
      let errors = Object.assign({}, validateErrors);
      delete errors.videoId;

      setValidateErrors({
        ...errors
      });
    }
    setCancelDebounce(false);
    setFilters({ ...filters, videoId: value });
  }

  const handleVideoIdSubmit = (videoId) => {
    setCancelDebounce(true);
    setFilters({ ...filters, videoId: videoId, reload: true });
  };

  const handleInputChange = (value, name) => {
    setFilters({ ...filters, [name]: value });
  }

  const handleInputSubmit = (value, name) => {
    setCancelDebounce(true);
    setFilters({ ...filters, [name]: value, reload: true });
  }

  const handleVideoUserChange = (option) => {
    setFilters({ ...filters, videoUser: option ? option.value : '' });
  }

  const handleVideoTypeChange = (option) => {
    if (filters.types.includes(option)) {
      setFilters({ ...filters, types: filters.types.filter((item) => item !== option) });
    } else {
      setFilters({ ...filters, types: [...filters.types, option] });
    }
  }

  const submitFilter = () => {
    if (!filters.keywords && !filters.videoId && !filters.videoOwner && !filters.videoUser) {
      if (keywordInput.current) keywordInput.current.focus();
      return;
    }

    if (validateErrors && validateErrors.videoId) {
      if (videoIdInput.current) videoIdInput.current.focus();
      return;
    }

    setCancelDebounce(true);
    if (onSubmitFilter) onSubmitFilter(filters);
  };

  useEffect(() => {
    if (filters.reload) {
      submitFilter();
      setFilters({ ...filters, reload: false });
    }
  }, [filters.reload]);

  return (
    <>
      <Row className={classNames('video-review-filter')} style={{ transition: 'visibility 0.5s, opacity 0.5s linear' }}>
        <Col lg="6" md="6" xs="6" className="mt-1 mb-1">
          <div className="item-filter reviewer-filter">
            <label htmlFor="" className="mb-0">Video id</label>
            <div className="d-inline-block ml-2 item-filter__control">
              <CustomInput
                name="videoId"
                className={classNames('w-100', { 'is-invalid': validateErrors.videoId ? true : false })}
                placeholder=""
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleVideoIdChange}
                onSubmit={handleVideoIdSubmit}
                innerRef={videoIdInput}
                maxLength="36"
              />
            </div>
          </div>
        </Col>

        <Col lg="6" md="6" xs="6" className="mt-1 mb-1">
          <div className="item-filter video-type-filter">
            <label htmlFor="" className="mb-0">Video owner</label>
            <div className="d-inline-block ml-2 item-filter__control">
              <CustomInput
                name="videoOwner"
                value={filters.videoOwner}
                className="w-100"
                placeholder=""
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleInputChange}
                onSubmit={handleInputSubmit}
              />
            </div>
          </div>
        </Col>
      </Row>      
      <Row>
        <Col lg="7" md="7" xs="7" className="mt-1 mb-1 d-flex">
          <div className="pt-1 mr-2">Types</div>
          <div className="pr-4 pt-1" style={{ display: 'flex', gap: '1rem', alignItems: 'center', border: 'solid 1px rgb(207, 213, 219)' }} >
            {VIDEO_TYPES.map((option, index) => (
              <div key={index} className="ml-2 w-100">
                <Input
                  type="checkbox"
                  id={`add-checkbox-${index}`}
                  checked={filters.types.includes(option)}
                  onChange={() => handleVideoTypeChange(option)}
                  className="ml-0"
                />
                <Label for={`add-checkbox-${index}`} className="ml-4">
                  {option}
                </Label>
              </div>
            ))}
          </div>
        </Col>
        <Col lg="5" md="5" xs="5" className="mt-1 mb-1">
          <div className="d-flex">
            <label htmlFor="" className="mb-0 mr-1">Keywords</label>
            <div className="w-100">
              <CustomInput
                name="keywords"
                value={filters.keywords}
                className="w-100"
                placeholder="Title, subject, topic..."
                disabled={fetching}
                debounceTime={3000}
                cancelDebounce={cancelDebounce}
                onChange={handleKeywordChange}
                onSubmit={handleKeywordSubmit}
                innerRef={keywordInput}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg="6" md="6" xs="6">
        </Col>
        <Col lg="6" md="6" xs="6" className="mt-1 mb-1 d-flex justify-content-end">
          <Button
            className="ml-3"
            size=""
            disabled={loading}
            // color="secondary"
            onClick={(e) => { setCancelDebounce(true); submitFilter(e); }}
          >
            <Icon.Search className="" style={{ width: '15px', height: '15px', marginTop: '-2px' }} /> Search video
          </Button>
          <div className="item-filter video-type-filter d-none">
            <label htmlFor="" className="mb-0">Video user</label>
            <div className="d-inline-block ml-2 item-filter__control">
              <SearchUserInput
                onChange={handleVideoUserChange}
                className="w-100"
                isClearable={true}
              />
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(VideoFilter);